import cn from 'classnames';
import { Typography } from 'seagull';
import WithLegendDot from "../WithLegendDot/WithLegendDot";
import { chartColors } from "../chartColors";
import styles from "./CustomTooltip.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders a tooltip to be used in recharts graphs using the recharts Tooltip component
 * with "content" prop.
 */
export default function CustomTooltip(props) {
  const {
    active,
    payload,
    label,
    testid,
    getItems,
    getTitle,
    getBody
  } = props;
  const isDark = props.skin === 'dark';
  const hasRelevantPayload = payload === null || payload === void 0 ? void 0 : payload.some(p => !!p.value);
  const title = getTitle ? getTitle(label, payload) : label;
  const items = getItems(payload === null || payload === void 0 ? void 0 : payload.filter(p => p.value)) || [];
  return active && hasRelevantPayload && items.length > 0 ? /*#__PURE__*/_jsxs("div", {
    className: cn(styles.root, isDark && styles.dark),
    "data-testid": testid,
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      skin: isDark ? 'invertedStandard' : 'secondary',
      weight: isDark ? 'bold' : 'light',
      "data-testid": testid && "".concat(testid, "-title"),
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: styles.separator
    }), getBody && /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      skin: isDark ? 'invertedStandard' : 'standard',
      "data-testid": testid && "".concat(testid, "-body"),
      children: getBody(payload)
    }), items.map((_ref, idx) => {
      let {
        id,
        label,
        color,
        dataKey,
        inBrackets
      } = _ref;
      return /*#__PURE__*/_jsx(WithLegendDot, {
        color: color || chartColors.lightGray,
        "data-testid": testid && "".concat(testid, "-item-").concat(idx),
        "data-key": dataKey,
        children: /*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph2",
          skin: isDark ? 'invertedStandard' : 'standard',
          children: [label, inBrackets && /*#__PURE__*/_jsxs(Typography, {
            as: "span",
            variant: "paragraph2",
            skin: "secondary",
            children: [' ', "(", inBrackets, ")"]
          })]
        })
      }, id);
    })]
  }) : null;
}